<template>
  <div class="add-options-message">
    <a
      v-if="!noAttachments"
      @click="$refs.attachments.click()"
      data-toggle="tooltip"
      data-placement="top"
      data-original-title="Add an attachment here"
    >
      <md-icon>attach_file</md-icon>
    </a>
    <div>
      <md-icon class="smile-size">mood</md-icon>

      <ul class="more-dropdown more-with-triangle triangle-bottom-right">
        <li
          v-for="(item, index) in emojis"
          :key="index"
          @click="$emit('emoji', item)"
        >
          <div class="h5" style="cursor: pointer">
            <p class="h5">{{ String.fromCodePoint(item) }}</p>
          </div>
        </li>
      </ul>
    </div>
    <input
      type="file"
      ref="attachments"
      @change="$emit('file', $event.target.files)"
      class="d-none"
      name="image"
    />
  </div>
</template>

<script>
import ChatHelperVue from "../../mixins/ChatHelper.vue";
export default {
  name: "ChatEmoji",
  mixins: [ChatHelperVue],
  props: ["noAttachments"],
  mounted() {
    $("[data-toggle='tooltip']").tooltip();
  },
};
</script>

<style lang="scss" scoped>
.add-options-message {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.smile-size {
  font-size: 26px;
  /* margin-right: 8px; */
  color: rgb(57, 86, 147) !important;
}
</style>
